import './FacilityList.scss';
import { AbsoluteRoutes, parseDurationToUIString, useGetFacilities, useTranslation } from '../../utils';
import { useNavigate } from 'react-router-dom';

function formatDuration(raw: string): string {
  const [hStr, mStr] = raw.split(':');
  const hours = parseInt(hStr, 10) || 0;
  const minutes = parseInt(mStr, 10) || 0;

  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours} год`);
  if (minutes > 0) parts.push(`${minutes} хв`);

  return parts.length > 0 ? parts.join(' ') : raw;
}

const FacilityList = () => {
  const { facilities } = useGetFacilities();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!facilities) return <></>;

  return (
    <div className='facility'>
      <h3 className='title'>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
          <path d='M4 4h16v16H4z' strokeLinecap='round' strokeLinejoin='round' />
          <path d='M4 9h16' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
        {t('Settings (expert).Tab_services')}
      </h3>
      <div className='facilityList'>
        {facilities.map((service, index) => {
          const name = typeof service.facility === 'object'
            ? (service.facility as any)?.name
            : service.facility;

          return (
            <div className='listItem' key={index}>
              <div className='itemTitle'>
                <button
                  type='button'
                  className='name'
                  onClick={() => navigate(AbsoluteRoutes.booking, { state: { facility: service } })}
                >
                  {name}
                </button>
                <span className='duration'>{formatDuration(parseDurationToUIString(service.duration))}</span>
              </div>
              {service.geolocation?.fullAddress && (
                <a
                  href={
                    service.geolocation.lat && service.geolocation.lon
                      ? `https://www.google.com/maps/search/?api=1&query=${service.geolocation.lon},${service.geolocation.lat}`
                      : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(service.geolocation.fullAddress)}`
                  }
                  target='_blank'
                  rel='noopener noreferrer'
                  className='location'
                >
                  <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                    <path d='M12 21s-7-6.5-7-11a7 7 0 0 1 14 0c0 4.5-7 11-7 11z' strokeLinecap='round' strokeLinejoin='round' />
                    <circle cx='12' cy='10' r='2.5' />
                  </svg>
                  {service.geolocation.fullAddress}
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FacilityList;